module.exports = __webpack_public_path__ + "static/img/story.cc317c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/story.jpg
// module id = 2P2X
// module chunks = 0